import { render, staticRenderFns } from "./SlotMachine.vue?vue&type=template&id=2592c8a4&scoped=true&"
import script from "./SlotMachine.vue?vue&type=script&lang=js&"
export * from "./SlotMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592c8a4",
  null
  
)

export default component.exports